import { useTranslation } from 'react-i18next';
import { pickLang } from '../lib/localeDisplay';

/** Lien d’évitement clavier → #main-content (SEO / a11y). */
export default function SkipToContent() {
  const { i18n } = useTranslation();
  const label = pickLang(i18n.language, {
    fr: 'Aller au contenu principal',
    de: 'Zum Hauptinhalt springen',
    en: 'Skip to main content',
    it: 'Vai al contenuto principale',
  });

  return (
    <a
      href="#main-content"
      className="absolute left-4 top-0 z-[100] -translate-y-[120%] focus:translate-y-4 bg-white text-primary-800 px-4 py-2 rounded-lg font-semibold outline-none ring-2 ring-primary-700 transition-transform"
    >
      {label}
    </a>
  );
}
